<template>
  <w-sliding-popup ref="slidingPopup" title="KEDB 정보" width="950px">
    <div slot="content">
      <w-kedb-detail-view :viewType="viewType" :params="params"></w-kedb-detail-view>
    </div>
  </w-sliding-popup>
</template>

<script>
import WKedbDetailView from '../KedbDetailView';

export default {
  name: 'WKedbDetailPopup',
  components: {
    WKedbDetailView,
  },
  props: {
    params: {
      type: Object,
    },
    viewType: {
      type: String,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    open() {
      this.$refs.slidingPopup.open();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/event/kedb/components/popup/KedbDetailPopup.vue